import SectionServices from "../components/pages/services/SectionServices"
import PageHeader from "../components/shared/PageHeader"

const Services = () => {
    return (
        <>
            <PageHeader title="At Medicare, Our Top Services" img={`/img/bg2.png`} />
            <SectionServices/>
        </>
    )
}

export default Services
